module.exports = __webpack_public_path__ + "img/gradient-2.80036d9b.png";